module.exports = __webpack_public_path__ + "static/media/copyright.cc3ce5d3.svg";